import React, {PropsWithChildren} from 'react';


export default function TotalRow({ label, children }: PropsWithChildren<{ label: string }>) {
    return (
        <div className="d-flex flex-row align-items-end my-1 gap-3 py-1">
            <b>{label}</b>
            <div className="d-inline-flex align-items-end me-2">
                {children}
            </div>
        </div>
    );
}
